import { Box, Flex, Text } from '@theme-ui/components';
import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';

import theme from '@app/styles/theme';
import { screenSmall } from '@app/styles/theme/breakpoints';
import { rem } from '@app/styles/theme/layout';

import type { StepState } from './StepsProgress.types';

const getStatusColor = (stepState: StepState): string => {
  if (stepState.isActive) return theme.colors.lightBlue;
  if (stepState.isPassed) return theme.colors.gradientGreen;
  return theme.colors.labelGray;
};

export const StepLine = styled.div<{ isLast: boolean }>`
  width: 100%;
  height: ${rem(2)};
  background-color: ${({ isLast }) =>
    isLast ? theme.colors.gradientGreen : theme.colors.labelGray};
  top: -6%;
  position: relative;
`;

export const StepDot = styled(Flex)`
  box-sizing: border-box;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  color: ${theme.colors.labelGray};
  font-weight: 500;
  padding: 0 ${theme.space[2]};
  position: relative;
`;

export const Circle = styled(Box, {
  shouldForwardProp: (prop) => isPropValid(prop),
})<{ stepState: StepState }>`
  width: ${rem(32)};
  height: ${rem(32)};
  position: relative;
  background-color: ${({ stepState }) => getStatusColor(stepState)};
  font-size: ${theme.fonts[3]};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  margin-bottom: ${theme.space[1]};
  color: ${theme.colors.white};
  transition: transform 0.3s ease-in-out;
  ${({ stepState }) =>
    stepState.isPassed &&
    `&:hover {
      transition: transform 0.3s ease-in-out;
      transform: scale(1.1);
      cursor: pointer;
    }`};
`;

export const Label = styled(Text, {
  shouldForwardProp: (prop) => isPropValid(prop),
})<{ stepState: StepState }>`
  font-size: ${theme.fontSizes[1]};
  white-space: nowrap;
  position: absolute;
  top: ${rem(40)};
  color: ${({ stepState }) => getStatusColor(stepState)};
  display: block;

  @media screen and (max-width: ${screenSmall}) {
    display: none;
  }
`;
